import { render, staticRenderFns } from "./FormDistribuicaoEmpresasEnderecos.vue?vue&type=template&id=88c78d2a&scoped=true&"
import script from "./FormDistribuicaoEmpresasEnderecos.vue?vue&type=script&lang=js&"
export * from "./FormDistribuicaoEmpresasEnderecos.vue?vue&type=script&lang=js&"
import style0 from "./FormDistribuicaoEmpresasEnderecos.vue?vue&type=style&index=0&id=88c78d2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c78d2a",
  null
  
)

export default component.exports